import { Col, Container, Form, Row, Stack } from 'react-bootstrap'
import { KTIcon } from '../../../../../_metronic/helpers'
import { useContext, useEffect, useState } from 'react'
import { PartnerContext } from '../PartnerContexts'
import { useDebounce } from 'use-debounce'
import { TableSearch } from '../../../../shared/TableSearch'
import { generateExcel, generateSimplifiedExcel } from '../../../../services/fichas'
import { getAllPartnersPag } from '../../../../services/colaboradores'
import * as excelJs from 'exceljs';
import { formatDateToDMY, formatISODateToDMYHM } from '../../../../helpers/dateFunctions'
import { getAllUsersPag } from '../../../../services/users'
import { useAuth2 } from '../../../authv2/Auth2Provider'

const PerfilListHeader = () => {
  const buttonsData = [
    {
      iconName: 'verify',
      title: 'Borrador',
      stateName: 'borrador',
      color: '#f39c12', // Orange
    },
    {
      iconName: 'security-user',
      title: 'Completado',
      stateName: 'completado',
      color: '#2ecc71', // Green
    }
  ]

  const [activeButtons, setActiveButtons] = useState(buttonsData.map(() => false))
  const { userData, selectedCompanyId } = useAuth2()
  const { searchTerm, setSearchTerm} =
    useContext(PartnerContext)

  const handleSearch = (value: string) => {
    setSearchTerm(value)
  }


  return (
    <>
      <div className='mx-8 mt-8 mb-2'>
        <Row>
          <Col>
            <span className='fw-bold'>Buscar</span>
            <Stack className=' mt-3' direction='horizontal' gap={3}>
              <TableSearch onSearch={handleSearch} design={true} />
            </Stack>
          </Col>
        </Row>
      </div>
    </>
  )
}

export { PerfilListHeader }
